module.exports = __webpack_public_path__ + "static/pulsio_box_opened_mobile-b2151b47a83e892906d0da6ec5eb54b9.png";